var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('van-nav-bar',{staticClass:"backBox",attrs:{"title":'人脸采集',"right-text":"","left-arrow":""},on:{"click-left":_vm.onClickLeft}}),_c('FaceRecognition',{on:{"resultImg":_vm.getResultImg}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }